var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-loader-dots",class:_vm.classes},[_c('div',{staticClass:"dots"},[_c('div',{staticClass:"bounce1",style:(_vm.style)}),_c('div',{staticClass:"bounce2",style:(_vm.style)}),_c('div',{staticClass:"bounce3",style:(_vm.style)})]),(_vm.overlay)?_c('div',{staticClass:"overlay"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }